import PropTypes from 'prop-types';
import React from 'react'

import { Pencil, Plus, Trash } from 'lucide-react';
import { Select, Row, Col, FormGroup, Label, Input, Button, DefaultTooltip, InputGroupText, InputGroup, Switch, FormSection, Checkbox, ButtonGroup, Separator, DefaultTable, ColorPickerInputGroup, ButtonIcon } from 'twyne-new.ui';

import CodeEditor from '@Components/form/CodeEditor';

class LinkoutQuestionForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      linkoutquestion: null,
      customFields: null,
      customFieldSelected: null
    }
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
    this.updateOptions(this.state.customFieldSelected);
  }

  updateCustomFields = ({ integrationData: { extraFields, linkoutquestion } }) => {
    const customFields = (extraFields || []).map(({
      id, group, type, options, key: value, name: label
    }) => ({
      id, group, type, options, value, label: `${label} (${type})`
    }));
    const customFieldSelected = customFields.find(field => linkoutquestion.cfid === field.value) || {};
    linkoutquestion.cfid_number = linkoutquestion.cfid_number || customFieldSelected.id;

    this.state = {
      linkoutquestion,
      customFields,
      customFieldSelected
    };

  }
  makeDefaultAnswer = (answer) => {
    return Object.assign({
      key: "",
      answer: "",
      fontcolor: "255,255,255,1",
      color: "113,113,113,1"
    }, answer);
  }

  addPostData = (answers, answer) => {
    answers.push(this.makeDefaultAnswer(answer));
    return answers
  }

  updateOptions = (cf) => {
    const { linkoutquestion } = this.state
    if (!cf) return;
    let isSelect = cf.type === 'select',
      isBoolean = cf.type === 'boolean';

    if (isBoolean || isSelect) {
      if (isSelect) {
        let answers = linkoutquestion.answers;
        let currentKeyAnswers = answers.map(({ key }) => key);
        let newKeysAnswers = cf.options.map(({ value: key }) => key);
        answers.forEach((answer, idx) => {
          !newKeysAnswers.includes(answer.key) && this.handleClickRemovePostData(idx);
        });
        cf.options.forEach(({ value: key, label: answer }) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData({ key, answer });
        });
      }
      if (isBoolean) {
        let answers = linkoutquestion.answers;
        let options = [{ key: "true", answer: "Yes" }, { key: "false", answer: "No" }];
        let currentKeyAnswers = answers.map(({ key }) => key);
        answers.forEach(({ key }, idx) => {
          !["true", "false"].includes(key) && this.handleClickRemovePostData(idx)
        });
        options.forEach(({ key, answer }, idx) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData(this.makeDefaultAnswer({ key, answer }))
        });
        return;
      }
      return;
    }
    linkoutquestion.answers = linkoutquestion.answers || [];
  }

  handleChangeAnswerInput = (idx, key, value) => {
    if (this.state.customFieldSelected.type === 'input' && !['color', 'fontcolor'].includes(key)) {
      value = value.replace(/[}{,()$]/g, '')
    }

    const answers = this.state.linkoutquestion.answers;

    if (!answers[idx]) {
      return this.handleChangeSkipAnswer(key, value)
    }

    if (!value && key === 'linkout')
      delete answers[idx]['url'];

    answers[idx][key] = value;
    this.props.onChange('answers', answers);
  }

  handleClickRemovePostData = (idx) => {
    const answers = this.state.linkoutquestion.answers
    answers.splice(idx, 1);
    this.props.onChange('answers', answers)
  }

  handleClickAddPostData = (answer) => {
    this.props.onChange('answers', this.addPostData(this.state.linkoutquestion.answers, answer))
  }

  handleEnableTrustedForm = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.linkoutquestion.cfid === null || this.state.linkoutquestion.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.linkoutquestion.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }

  }

  handleEnableLeadId = e => {
    const { checked } = e.target

    if (checked) {
      if (this.state.linkoutquestion.cfid === null || this.state.linkoutquestion.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.linkoutquestion.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }

  }
  handleCustomFieldEdit = (cfid) => {
    this.props.onCustomFieldClick({
      cfid,
      customFieldOpen: true
    })
  }

  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }

  handleChangeSkip = ({ target: { checked } }) => {
    this.handleEnable('skipOption').call(this, { target: { checked } })
    const skipOpt = checked ? { key: '$skip', answer: 'Skip', fontcolor: "255,255,255,1", color: "113,113,113,1", disabled: true } : null
    this.props.onChange('skipAnswer', skipOpt)
  }

  handleChangeSkipAnswer = (key, value) => {
    const { skipAnswer } = this.state.linkoutquestion
    skipAnswer[key] = value
    this.props.onChange('skipAnswer', skipAnswer)
  }

  handleChangeCustomField = cf => {
    const { linkoutquestion } = this.state
    const cfid = cf ? cf.value : null
    this.props.onChange('cfid_number', cf ? `${cf.id}` : null);
    this.props.onChange('cfid', cfid)
    linkoutquestion.answers = []
    this.updateOptions(cf)
    this.props.onChange('answers', linkoutquestion.answers)
    this.props.onChange('isMultipleAnswers', false)
    this.props.onChange('manualSubmit', false)
    const { leadid, trustedform } = linkoutquestion
    leadid && this.props.onChange('leadid_cfid', `${cfid}_leadid`)
    trustedform && this.props.onChange('trustedform_cfid', `${cfid}_trustedform`)
  }

  renderAnswerTypes = () => {
    const { linkoutquestion } = this.state
    const options = linkoutquestion.answers = linkoutquestion.answers || [];

    let { handleChangeAnswerInput, handleClickRemovePostData } = this,
      oAProps = {
        options,
        handleChangeAnswerInput,
        disabled: this.props.disabled,
        handleClickRemovePostData,
        skipAnswer: linkoutquestion.skipAnswer,
        skipOption: linkoutquestion.skipOption,
      };
    switch (this.state.customFieldSelected.type) {
      case 'select':
      case 'boolean':
        oAProps.keysDisabled = true;
        break;
      case 'integer':
        oAProps.keyInputType = 'number';
        break;
      default:
        break;
    }
    return <OptionsAnswer {...oAProps} />
  }

  render() {
    return (
      <div key={this.state.linkoutquestion.cfid || ''}>
        <Row>
          <Col size="6">
            <FormGroup>
              <Label>Custom Field</Label>
              <Select name="type" value={this.state.linkoutquestion.cfid || ''} options={this.state.customFields}
                onChange={this.handleChangeCustomField} disabled={this.props.disabled} />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>&nbsp;</Label>
              <ButtonGroup>
                <Button color="accent" disabled={this.props.disabled} onClick={() => this.handleCustomFieldEdit()}>
                  <Plus size={14} />
                  Add
                </Button>
                <DefaultTooltip content='Edit' triggerProps={{ asChild: true }}>
                  <Button variant='outline' color="accent" disabled={this.props.disabled || !this.state.linkoutquestion.cfid_number} onClick={() => this.handleCustomFieldEdit(this.state.linkoutquestion.cfid_number)}>
                    <Pencil size={14} />
                  </Button>
                </DefaultTooltip>
              </ButtonGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={e => this.handleEnableTrustedForm(e)}
                checked={this.state.linkoutquestion.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={e => this.handleEnableLeadId(e)}
                checked={this.state.linkoutquestion.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.linkoutquestion.alwaysShow || false}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Consent text</Label>
              <Switch
                onChange={this.handleEnable('consentTextActive')}
                checked={this.state.linkoutquestion.consentTextActive || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.linkoutquestion.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size="2">
            <FormGroup>
              <Label>Skip option</Label>
              <Switch
                onChange={this.handleChangeSkip}
                checked={this.state.linkoutquestion.skipOption || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>Question</Label>
              <CodeEditor
                resizable
                height="100px"
                name="question"
                value={this.state.linkoutquestion.question || ''}
                onChange={value => this.props.onChange('question', value)}
                disabled={this.props.disabled}
                width="100%"
              />
            </FormGroup>
          </Col>
          <Col>
            <Separator />
          </Col>
          <Col size="12" className='flex justify-between items-center'>
            <FormSection>
              Answers
            </FormSection>
            <DefaultTooltip
              content={!['integer', 'input'].includes(this.state.customFieldSelected.type) && 'Custom fields needs to be of type integer or input to add answers.'}>
              <Button
                disabled={!['integer', 'input'].includes(this.state.customFieldSelected.type) || this.props.disabled}
                color="accent"
                size="sm"
                onClick={() => this.handleClickAddPostData()}
              >
                <Plus size={14} />
                Add
              </Button>
            </DefaultTooltip>
          </Col>
          <Col size="12">
            {this.renderAnswerTypes()}
          </Col>
          {this.state.linkoutquestion.consentTextActive && <>
            <Col size="12">
              <FormGroup>
                <Label>Consent text</Label>
                <CodeEditor
                  name="consentText"
                  value={this.state.linkoutquestion.consentText || ''}
                  onChange={value => this.props.onChange('consentText', value)}
                  disabled={this.props.disabled}
                  resizable
                  height="100px"
                />
              </FormGroup>
            </Col>
          </>}
        </Row>
      </div>
    );
  }
}

LinkoutQuestionForm.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func,
}

const OptionsAnswer = ({ options, keysDisabled, keyInputType, handleChangeAnswerInput, handleClickRemovePostData, disabled, skipAnswer, skipOption }) => {
  const columns = [
    {
      dataField: 'key',
      text: 'Key',
      formatter: (value, row, index) => <Input
        type={keyInputType}
        disabled={keysDisabled || disabled || value === '$skip'}
        value={value}
        onChange={e => handleChangeAnswerInput(index, 'key', e.target.value)}
        placeholder="Key"
      />,
    },
    {
      dataField: 'answer',
      text: 'Answer',
      formatter: (value, row, index) => <Input
        value={value}
        disabled={disabled}
        onChange={e => handleChangeAnswerInput(index, 'answer', e.target.value)}
        placeholder="Answer"
      />,
    },
    {
      dataField: 'linkout',
      text: 'Linkout',
      formatter: (value, row, index) => <InputGroup className="w-auto">
        <InputGroupText addonType='append'>
          <Checkbox
            checked={value}
            onChange={checked => handleChangeAnswerInput(index, 'linkout', checked)}
            disabled={disabled}
          />
        </InputGroupText>
        <Input
          type="url"
          key={value}
          value={row.url}
          disabled={!value || disabled}
          placeholder={!value ? 'linkout disabled' : null}
          onChange={e => handleChangeAnswerInput(index, 'url', e.target.value)}
        />
      </InputGroup>,
    },
    ...!disabled ? [
      {
        dataField: 'color',
        text: '',
        className: 'w-8',
        formatter: (value, row, index) => <DefaultTooltip content='Button Background Color' side='bottom' triggerProps={{ asChild: true }}>
          <ColorPickerInputGroup
            value={value}
            onChange={value => handleChangeAnswerInput(index, 'color', value?.rgbaParsed.replace('rgba(', '').replace(')', ''))}
            components={['picker', 'preview']}
          />
        </DefaultTooltip>,
      },
      {
        dataField: 'fontcolor',
        text: '',
        className: 'w-8',
        formatter: (value, row, index) => <DefaultTooltip content='Button Font Color' side='bottom' triggerProps={{ asChild: true }}>
          <ColorPickerInputGroup
            key={`${row.key}-f${index}`}
            value={value}
            onChange={value => handleChangeAnswerInput(index, 'fontColor', value?.rgbaParsed.replace('rgba(', '').replace(')', ''))}
            components={['picker', 'preview']}
          />
        </DefaultTooltip>,
      },
    ] : [],
    ...!keysDisabled ? [
      {
        dataField: '',
        text: '',
        className: 'w-8',
        formatter: (_, row, index) => <ButtonIcon content='Delete' onClick={() => handleClickRemovePostData(index)} disabled={disabled}>
          <Trash size={16} />
        </ButtonIcon>,
      },
    ] : [],
  ]

  return (
    <DefaultTable
      data={skipOption ? [...options, skipAnswer] : options}
      columns={columns}
      noDataIndication={() => 'No answers to show.'}
      className='max-h-[30vh] overflow-y-auto'
    />
  )
}

export default LinkoutQuestionForm
